var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskUsersTimeSpent)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('vue-good-table',{attrs:{"columns":_vm.userColumns,"rows":_vm.taskUsersTimeSpent}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }